<template>
  <div id="privilege-information-mobile-topup-form" class="form-custom">
    <b-row class="mobile-topup-form">
      <b-col cols="12">
        <b-card no-body class="mb-1 pb-2">
          <b-card-header>
            <span class="information-header">Mobile Topup</span>
          </b-card-header>
          <b-row class="px-5">
            <b-col cols="12">
              <b-row>
                <b-col cols="12">
                  <b-form-group
                    :label="'Carriers'"
                    label-for="carriers"
                    label-class="font-medium-5"
                  >
                    <div class="d-flex flex-wrap">
                      <div
                        v-for="carrier in carriersList"
                        :key="carrier.carrierId + '-carrier'"
                        class="topup-carrier-wrp"
                        :class="[
                          carrierSelect.id.indexOf(carrier.carrierId) != -1 &&
                            `active ${carrier.name}`,
                          isEdit && 'disabled',
                        ]"
                        @click="onSelectCarrier(carrier.carrierId)"
                      >
                        <img
                          :src="carrier.icon"
                          class="topup-carrier-image m-auto"
                          alt=""
                          draggable="false"
                        />
                      </div>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group
                    :label="'Topup value'"
                    label-for="topup-value"
                    label-class="font-medium-5"
                  >
                    <div class="d-flex flex-wrap">
                      <div
                        class="topup-value-wrp"
                        v-for="topupValue in carrierSelect.value"
                        :key="topupValue + '-value'"
                        :class="[
                          carrierSelect.valueSelect == topupValue && 'active',
                          isEdit && 'disabled',
                        ]"
                        @click="onSelectValue(topupValue)"
                      >
                        <span>{{ topupValue }} Baht</span>
                      </div>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { computed, reactive, ref, watch } from "@vue/composition-api";
import { carriersList, allValue } from "@/configs/privilege/topup.js";
export default {
  components: {},
  props: { isEdit: { type: Boolean, default: false } },
  setup(props) {
    const carrierSelect = reactive({
      id: [1],
      value: allValue,
      valueSelect: 0,
    });

    const setCarrierSelect = (id, valueSelect) => {
      carrierSelect.id = id;
      carrierSelect.valueSelect = valueSelect;
      resolveValueList();
    };

    const getCarrierSelect = () => {
      return {
        carrierFlag:
          carrierSelect.id.length > 0
            ? carrierSelect.id.reduce((previous, current) => previous + current)
            : 0,
        value: carrierSelect.valueSelect,
      };
    };

    const onSelectCarrier = (id) => {
      if (props.isEdit) return;
      let carrier = carrierSelect.id.find((o) => {
        return o == id;
      });
      if (carrier) {
        carrierSelect.id = [
          ...carrierSelect.id.filter((o) => {
            return o != id;
          }),
        ];
      } else {
        carrierSelect.id.push(id);
      }
      carrierSelect.valueSelect = 0;
      resolveValueList();
    };

    const resolveValueList = () => {
      carrierSelect.value = allValue;
      carrierSelect.id.forEach((id) => {
        let arr = carrierSelect.value.concat(
          carriersList.find((o) => {
            return o.carrierId == id;
          }).value
        );
        carrierSelect.value = getArrDuplicate(arr);
      });
    };

    const onSelectValue = (value) => {
      if (props.isEdit) return;
      carrierSelect.valueSelect = value;
    };

    const getArrDuplicate = (arr) => {
      const yourArrayWithoutDuplicates = [...new Set(arr)];

      let duplicates = [...arr];
      yourArrayWithoutDuplicates.forEach((item) => {
        const i = duplicates.indexOf(item);
        duplicates = duplicates
          .slice(0, i)
          .concat(duplicates.slice(i + 1, duplicates.length));
      });

      return duplicates;
    };

    return {
      carrierSelect,
      carriersList,
      onSelectCarrier,
      onSelectValue,
      setCarrierSelect,
      getCarrierSelect,
    };
  },
};
</script>
